import { Record } from 'immutable'
import { AssociatedContact, IAssociatedContact } from './AssociatedContact'

export interface IIndividualAmount {
  readonly amount: number
  readonly contact?: IAssociatedContact
}

const IndividualAmountRecord = Record({
  amount: 0,
  contact: undefined,
})

export class IndividualAmount extends IndividualAmountRecord
  implements IIndividualAmount {
  public static fromJS(initialState?: Partial<IIndividualAmount>) {
    if (!initialState) {
      return new IndividualAmount()
    }

    const { contact, ...rest } = initialState

    return new IndividualAmount({
      contact: contact ? AssociatedContact.fromJS(contact) : undefined,
      ...rest,
    })
  }

  public readonly amount: number
  public readonly contact?: IAssociatedContact

  constructor(props?: Partial<IndividualAmount>) {
    props ? super(props) : super()
  }
}
